import script from "./UnitDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnitDetail.vue?vue&type=script&setup=true&lang=ts"

import "./UnitDetail.vue?vue&type=style&index=0&id=8ca28a92&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ca28a92"]])

export default __exports__